import React, { useState } from 'react';
import Sidebar from '../Components/Sidebar';
import { TfiHandPointRight } from "react-icons/tfi";
import './Elevation.css'; // Reuse existing styles

const Structural = () => {
  const [zoomImage, setZoomImage] = useState(null);

  // 10 Structural sample images from /public/gallery/structural/structural_1.jpg to structural_10.jpg
const structuralImages = ['/gallery/structural/structural_1.jpg', '/gallery/structural/structural_2.png', '/gallery/structural/structural_3.png', '/gallery/structural/structural_4.png', '/gallery/structural/structural_5.png', '/gallery/structural/structural_6.png', '/gallery/structural/structural_7.png', '/gallery/structural/structural_8.png', '/gallery/structural/structural_9.png', '/gallery/structural/structural_10.png'];

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />

      <div className="elevation-content">
        <h1 className="service-title">STRUCTURAL DRAWINGS</h1>

        {/* Main hero image */}
        <div className="service-image">
          <img src="/gallery/structural/structural_3.png" alt="Structural Drawing" />
        </div>

        <h3>Why Choose Our Structural Drafting Services?</h3>
        <ul className="draftsman-points">
          <li><TfiHandPointRight /> Accurate RCC and steel structure drawings</li>
          <li><TfiHandPointRight /> Foundation, beam, column, and slab detailing</li>
          <li><TfiHandPointRight /> Expertise in AutoCAD, STAAD Pro & Revit Structure</li>
          <li><TfiHandPointRight /> Design validation and code compliance</li>
        </ul>

        {/* Image Grid Section */}
        <div className="image-grid-section">
          <h2>Gallery of Structural Samples</h2>
          <div className="image-grid">
            {structuralImages.map((src, index) => (
              <div
                className="grid-image-box"
                key={index}
                onClick={() => setZoomImage(src)}
              >
                <img src={src} alt={`Structural Sample ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        {/* Contact Section */}
        <div className="service-contact">
          <h2>Contact Us for More Information</h2>
          <p>If you have any questions or would like to discuss your project, please contact us:</p>
          <ul>
            <li>Email: <a href="mailto:blessedandblessed247@gmail.com">blessedandblessed247@gmail.com</a></li>
            <li>Phone: <a href="tel:+231770508020">+231 770-508-020</a>, <a href="tel:+919908526058">+91 99085 26058</a></li>
          </ul>
        </div>
      </div>

      {/* Zoom Modal */}
      {zoomImage && (
        <div className="image-modal" onClick={() => setZoomImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={() => setZoomImage(null)}>❌</span>
            <img src={zoomImage} alt="Zoomed View" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Structural;
